module.exports = __webpack_public_path__ + "img/railRodParts.250fe13b.png";